import { darken, lighten, Palette, PaletteMode } from "@mui/material";
import { createTheme } from "@mui/material/styles";

export const customPalette = (mode: PaletteMode): Palette => {
  return createTheme({
    palette: {
      primary: {
        main: mode === "light" ? "#000000" : "#71C5E8",
        light: mode === "light" ? "#235F73" : "#235F73",
        dark: mode === "light" ? lighten("#71C5E8", 0.6) : darken("#71C5E8", 0.095),
        contrastText: mode === "light" ? "#FFFFFF" : "#FFFFFF",
      },
      secondary: {
        main: mode === "light" ? "#71C5E8" : "#235f73",
        light: mode === "light" ? darken("#71C5E8", 0.16) : "#71C5E8",
        dark: mode === "light" ? darken("#71C5E8", 0.24) : "#71C5E8",
        contrastText: mode === "light" ? "#FFFFFF" : "#FFFFFF",
      },
      header: {
        main: "#000000",
        contrastText: "#FFFFFF",
      },
      background: {
        // BACKGROUND
        default: mode === "light" ? "#FFFFFF" : "#121212",
        // SURFACE
        paper: mode === "light" ? "#FFFFFF" : "#333333",
      },
      text: {
        // ON BACKGROUND
        primary: mode === "light" ? "#000000" : "#FFFFFF",
        // ON SURFACE
        secondary: mode === "light" ? "#333333" : "#FFFFFF",
        disabled: mode === "light" ? "#6A6A6A" : "#999999",
      },
      divider: mode === "light" ? "#888888" : "#767676",
      error: {
        main: mode === "light" ? "#CC0000" : "#ED9B96",
        contrastText: mode === "light" ? "#FFFFFF" : "#121212",
        light: mode === "light" ? darken("#CC0000", 0.16) : "#FF3333",
        dark: mode === "light" ? darken("#CC0000", 0.24) : "#990000",
      },
      grey: {
        200: mode === "light" ? darken("#FFFFFF", 0.06) : "#555555",
        300: mode === "light" ? darken("#FFFFFF", 0.12) : "#7A7A7A",
        400: mode === "light" ? "#2F2F2F" : "#D6D6D6",
        500: mode === "light" ? lighten("#000000", 0.24) : "#ADADAD",
        900: mode === "light" ? lighten("#000000", 0.16) : "#EDEDED",
      },
      warning: {
        main: mode === "light" ? "#CCAA1D" : "#CCAA1D",
        contrastText: mode === "light" ? "#FFFFFF" : "#121212",
      },
      success: {
        main: mode === "light" ? "#138235" : "#80C593",
        light: "#4DE17A",
        contrastText: mode === "light" ? "#FFFFFF" : "#121212",
      },
      info: {
        main: mode === "light" ? "#235F73" : "#80BAEC",
        light: mode === "light" ? "#E6EBFF" : "#71C5E8",
        dark: "#839AFF",
        contrastText: mode === "light" ? "#FFFFFF" : "#121212",
      },
    },
  }).palette;
};
